import React from 'react';
import Aac from './Aac.js';
import Ai from './Ai.js';
import Avi from './Avi.js';
import Csv from './Csv.js';
import Doc from './Doc.js';
import Docx from './Docx.js';
import Empty from './Empty.js';
import Fla from './Fla.js';
import Flac from './Flac.js';
import Gif from './Gif.js';
import Htm from './Htm.js';
import Html from './Html.js';
import Jpeg from './Jpeg.js';
import Jpg from './Jpg.js';
import Mov from './Mov.js';
import Mp3 from './Mp3.js';
import Mp4 from './Mp4.js';
import Pdf from './Pdf.js';
import Png from './Png.js';
import Ppt from './Ppt.js';
import Ps from './Ps.js';
import Tiff from './Tiff.js';
import Txt from './Txt.js';
import Xls from './Xls.js';
import Xlsx from './Xlsx.js';
import Xml from './Xml.js';
const FileTypes = {
    aac: Aac,
    ai: Ai,
    avi: Avi,
    csv: Csv,
    doc: Doc,
    docx: Docx,
    fla: Fla,
    flac: Flac,
    gif: Gif,
    htm: Htm,
    html: Html,
    jpg: Jpg,
    jpeg: Jpeg,
    mov: Mov,
    mp3: Mp3,
    mp4: Mp4,
    pdf: Pdf,
    png: Png,
    ps: Ps,
    tiff: Tiff,
    txt: Txt,
    xls: Xls,
    xlsx: Xlsx,
    xml: Xml,
    pptx: Ppt,
};
export const availableFileTypes = Object.keys(FileTypes);
const isSupported = (type) => !!FileTypes[type];
const FileType = ({ type, ...props }) => {
    if (isSupported(type)) {
        return React.createElement(FileTypes[type], props);
    }
    return React.createElement(Empty, props);
};
export default React.memo(FileType);
